import Button from "./Button";
import Icon from "./Icon";

/*
  Figma "Empty state": a 64px icon circle, title, message and an optional action,
  centred with 40px of air above and below.
*/
const EmptyState = ({ icon, title, message, actionLabel, onAction, className = "" }) => (
  <div className={`flex flex-col items-center gap-space-8 px-space-24 py-space-40 text-center ${className}`}>
    {icon && (
      <span className="mb-space-4 flex size-[64px] items-center justify-center rounded-full bg-icon-badge-bg text-icon-badge-fg">
        <Icon name={icon} size={28} />
      </span>
    )}
    <p className="text-title-3 text-label-primary">{title}</p>
    {message && <p className="text-subheadline text-label-secondary">{message}</p>}
    {actionLabel && (
      <Button size="m" className="mt-space-8" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
